<div class="w-100 separator mt-4 mb-5"></div>
<div class="duration mt-5">
  <div
    *ngIf="transactionTypeTexts$ | async as transactionTypeTexts"
    class="duration-label col-12 col-sm-3 col-md-4 col-lg-3 udex-me-lg-12 udex-me-md-0 udex-me-sm-12">
    <h3
      class="body--s"
      data-cy="contract-duration-label">
      {{ transactionTypeTexts.duration }}
    </h3>
  </div>
  <div class="col-12 col-sm-9 col-lg-9 udex-mt-8 udex-me-sm-12">
    <ng-container #fieldComponent>
      <!-- fieldGroup configured in FormlyFieldConfig will be rendered here -->
    </ng-container>
  </div>
</div>
